export default "__VITE_ASSET__6GgVtuov__"